// ----------------------------------------------------------------------------
// Section: FAQs
// ----------------------------------------------------------------------------
//
// FAQs Section
// - Based on the Accordion pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block';

// Styles
import './_faqs.scss';


// Scripts for Videos
function AccordionVideo() {
    const AccordionVideos = document.querySelectorAll('.accordion__video');

    for (const AccordionVideo of AccordionVideos) {
        var mobileSrc = AccordionVideo.dataset.mobileSrc;
        var desktopSrc = AccordionVideo.dataset.src;

        // switching the video source for mobile vs desktop screens
        if (window.innerWidth < 680) {
            if (mobileSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = mobileSrc;

                while (AccordionVideo.firstChild) {
                    AccordionVideo.removeChild(AccordionVideo.firstChild);
                }
                AccordionVideo.appendChild(source);
                AccordionVideo.load();
            }
        } else {
            if (desktopSrc) {
                var source = document.createElement('source');
                source.type="video/mp4";
                source.src = desktopSrc;

                while (AccordionVideo.firstChild) {
                    AccordionVideo.removeChild(AccordionVideo.firstChild);
                }
                AccordionVideo.appendChild(source);
                AccordionVideo.load();
            }
        }
    }

}

AccordionVideo();
